export const TRAVEL_RULE_OWNERSHIP = [
  { id: "self", label: "Minha titularidade" },
  { id: "third_party", label: "Terceiros" },
];

export const TRAVEL_RULE_WALLET_TYPES = [
  { id: "self_custody", label: "Custódia Própria (Self-custody)" },
  { id: "exchange_vasp", label: "Instituição Receptora (Exchange/VASP)" },
];

export const TRAVEL_RULE_BENEFICIARY_TYPES = [
  { id: "domestic_pf", label: "Pessoa física" },
  { id: "domestic_pj", label: "Pessoa jurídica" },
  { id: "foreign", label: "Estrangeiro" },
];

export const TRAVEL_RULE_DESTINATION_COUNTRIES = [
  { id: "BR", label: "Brasil" },
  { id: "US", label: "Estados Unidos" },
  { id: "PT", label: "Portugal" },
  { id: "AR", label: "Argentina" },
  { id: "UY", label: "Uruguai" },
  { id: "PY", label: "Paraguai" },
  { id: "CL", label: "Chile" },
  { id: "CO", label: "Colômbia" },
  { id: "MX", label: "México" },
  { id: "GB", label: "Reino Unido" },
  { id: "DE", label: "Alemanha" },
  { id: "FR", label: "França" },
  { id: "ES", label: "Espanha" },
  { id: "IT", label: "Itália" },
  { id: "CH", label: "Suíça" },
  { id: "CA", label: "Canadá" },
  { id: "JP", label: "Japão" },
  { id: "CN", label: "China" },
  { id: "AE", label: "Emirados Árabes Unidos" },
  { id: "OTHER", label: "Outro país" },
];

export const TRAVEL_RULE_TRANSACTION_PURPOSES = [
  { id: "32999", code: "32999", label: "Viagem internacional", category: null },
  { id: "37994", code: "37994", label: "Doação ou outra transferência sem contrapartida", category: null },
  {
    id: "67995",
    code: "67995",
    label: "Transferência entre contas da mesma pessoa natural ou jurídica",
    category: null,
  },
  { id: "12995", code: "12995", label: "Compra ou venda de mercadoria", category: null },
  {
    id: "46002",
    code: "46002",
    label: "Serviço de computação e de informação",
    category: "Compra ou venda de serviço",
  },
  { id: "46978", code: "46978", label: "Serviço de negócio", category: "Compra ou venda de serviço" },
  { id: "46992", code: "46992", label: "Outro serviço", category: "Compra ou venda de serviço" },
  { id: "72980", code: "72980", label: "Principal", category: "Crédito externo" },
  { id: "72997", code: "72997", label: "Juros", category: "Crédito externo" },
  { id: "91992", code: "91992", label: "Demais", category: "Crédito externo" },
];

export const EMPTY_TRAVEL_RULE_FORM = {
  ownership: "",
  walletType: "",
  beneficiaryType: "",
  legalName: "",
  document: "",
  beneficiaryName: "",
  internationalId: "",
  destinationCountry: "",
  transactionPurpose: "",
};

const findOptionLabel = (options, id) => options.find((item) => item.id === id)?.label || "";

export const findTravelRulePurpose = (purposeId) =>
  TRAVEL_RULE_TRANSACTION_PURPOSES.find((item) => item.id === purposeId);

export const buildTravelRulePayload = (form, accountData = {}) => {
  const purpose = findTravelRulePurpose(form.transactionPurpose);
  const ownershipLabel = findOptionLabel(TRAVEL_RULE_OWNERSHIP, form.ownership);
  const walletTypeLabel = findOptionLabel(TRAVEL_RULE_WALLET_TYPES, form.walletType);
  const beneficiaryTypeLabel = findOptionLabel(TRAVEL_RULE_BENEFICIARY_TYPES, form.beneficiaryType);
  const destinationCountryLabel = findOptionLabel(TRAVEL_RULE_DESTINATION_COUNTRIES, form.destinationCountry);

  if (form.ownership === "self") {
    return {
      ownership: form.ownership,
      ownershipLabel,
      walletType: form.walletType,
      walletTypeLabel,
      beneficiaryType: null,
      beneficiaryTypeLabel: null,
      fullName: accountData.userName || "",
      document: accountData.userDocument || "",
      legalName: "",
      beneficiaryName: accountData.userName || "",
      internationalId: "",
      destinationCountry: form.destinationCountry,
      destinationCountryLabel,
      transactionPurpose: form.transactionPurpose,
      transactionPurposeLabel: purpose ? `${purpose.label} (${purpose.code})` : "",
      transactionPurposeCode: purpose?.code || "",
    };
  }

  const isForeign = form.beneficiaryType === "foreign";
  const isLegalEntity = form.beneficiaryType === "domestic_pj" || form.walletType === "exchange_vasp";

  return {
    ownership: form.ownership,
    ownershipLabel,
    walletType: form.walletType,
    walletTypeLabel,
    beneficiaryType: form.beneficiaryType,
    beneficiaryTypeLabel,
    fullName: isForeign ? form.beneficiaryName : isLegalEntity ? form.legalName : form.beneficiaryName,
    document: isForeign ? form.internationalId : form.document,
    legalName: form.legalName,
    beneficiaryName: form.beneficiaryName,
    internationalId: form.internationalId,
    destinationCountry: form.destinationCountry,
    destinationCountryLabel,
    transactionPurpose: form.transactionPurpose,
    transactionPurposeLabel: purpose ? `${purpose.label} (${purpose.code})` : "",
    transactionPurposeCode: purpose?.code || "",
  };
};

export const validateTravelRuleForm = (form, accountData = {}) => {
  if (!form?.ownership) {
    return { valid: false, message: "Selecione a titularidade da carteira de destino." };
  }
  if (!form.walletType) {
    return { valid: false, message: "Selecione o tipo da carteira de destino." };
  }
  if (!form.destinationCountry) {
    return { valid: false, message: "Selecione o país de destino." };
  }
  if (!form.transactionPurpose) {
    return { valid: false, message: "Selecione a finalidade da transação." };
  }

  if (form.ownership === "self") {
    if (!accountData.userName?.trim()) {
      return { valid: false, message: "Dados da conta indisponíveis para o Travel Rule." };
    }
    if (!accountData.userDocument?.trim()) {
      return { valid: false, message: "Documento da conta indisponível para o Travel Rule." };
    }
    return { valid: true };
  }

  if (form.walletType === "exchange_vasp") {
    if (!form.legalName?.trim()) {
      return { valid: false, message: "Informe a razão social do beneficiário." };
    }
    if (!form.document?.trim()) {
      return { valid: false, message: "Informe o CNPJ do beneficiário." };
    }
    return { valid: true };
  }

  if (!form.beneficiaryType) {
    return { valid: false, message: "Selecione o tipo do beneficiário." };
  }

  if (form.beneficiaryType === "foreign") {
    if (!form.beneficiaryName?.trim()) {
      return { valid: false, message: "Informe o nome do beneficiário." };
    }
    if (!form.internationalId?.trim()) {
      return { valid: false, message: "Informe o ID internacional do beneficiário." };
    }
    return { valid: true };
  }

  if (form.beneficiaryType === "domestic_pj") {
    if (!form.legalName?.trim()) {
      return { valid: false, message: "Informe a razão social do beneficiário." };
    }
    if (!form.document?.trim()) {
      return { valid: false, message: "Informe o CNPJ do beneficiário." };
    }
    return { valid: true };
  }

  if (!form.beneficiaryName?.trim()) {
    return { valid: false, message: "Informe o nome do beneficiário." };
  }
  if (!form.document?.trim()) {
    return { valid: false, message: "Informe o documento do beneficiário." };
  }

  return { valid: true };
};
